const template = contact => `
    <div class="c-footer__item o-layout__item u-1/3@small u-1/4@medium">
        <h4>${contact.label}</h4>
        <p><a href="mailto:${contact.address}">${contact.address}</a></p>
    </div>
  `

const createTemplates = (contacts) => {
  document
    .querySelector('.js-contacts')
    .insertAdjacentHTML('afterbegin', contacts.map(contact => template(contact)).join(''))
}

const enable = () => {
  if (window.contactsJSON) {
    createTemplates(window.contactsJSON.contacts)
  }
}

export default { enable }
